var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"hamburger",staticClass:"hamburger",on:{"click":_vm.toggleMenu}},[_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }